import { render, staticRenderFns } from "./LottiePlayer.vue?vue&type=template&id=dad415a4&scoped=true"
import script from "./LottiePlayer.vue?vue&type=script&lang=js"
export * from "./LottiePlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad415a4",
  null
  
)

export default component.exports